"use client";

import type { ComponentProps, ReactNode } from "react";

import TithiTodayClient from "./TithiTodayClient";
import TithiTodayControl from "./TithiTodayControl";
import { useDailyTimingExperiment } from "./daily-timing-experiment";

type Props = Omit<ComponentProps<typeof TithiTodayClient>, "crossLinks" | "telemetry"> & {
  controlCrossLinks: ReactNode;
  treatmentCrossLinks: ReactNode;
};

export default function TithiTodayExperimentSurface({
  controlCrossLinks,
  treatmentCrossLinks,
  ...props
}: Props) {
  const language = props.language ?? "en";
  const sourcePath = props.sourcePath ?? (language === "hi" ? "/hi/tithi-today" : "/tithi-today");
  const experiment = useDailyTimingExperiment(language, sourcePath);

  if (!experiment.isTreatment) {
    return (
      <TithiTodayControl
        {...props}
        language={language}
        sourcePath={sourcePath}
        telemetry={experiment.telemetry}
        crossLinks={controlCrossLinks}
      />
    );
  }

  return (
    <TithiTodayClient
      {...props}
      language={language}
      sourcePath={sourcePath}
      telemetry={experiment.telemetry}
      crossLinks={treatmentCrossLinks}
    />
  );
}
